import { Paper, Stack } from "@mui/material";

import { NewsFeedItemAddCommentInput } from "./AddCommentInput";
import { NewsFeedItemCommentList } from "./CommentList";
import { type NewsFeedItemComment } from "./types";

export interface NewsFeedItemCommentSectionProps {
  newsFeedItemId: string;
  comments: NewsFeedItemComment[];
}

export function NewsFeedItemCommentSection(props: NewsFeedItemCommentSectionProps) {
  const { newsFeedItemId, comments } = props;

  return (
    <Paper component={Stack} p={2} spacing={3} minHeight="300px" justifyContent="space-between">
      <NewsFeedItemCommentList comments={comments} />
      <NewsFeedItemAddCommentInput newsFeedItemId={newsFeedItemId} />
    </Paper>
  );
}
